import React from 'react'
import styled from 'styled-components'
import { Link } from "react-router-dom"
import { useMediaQuery } from 'react-responsive'

const Button = styled.button`
  font-family: Roboto;
  font-size: 2em;
  margin: .25em;
  padding: 0.25em;
  border: 7px solid white;
  border-radius: 5px;
  background: black;
  color: white;
  width: 175px;
  cursor: pointer;
`

const Nav = styled.ul`
  list-style-type: none;
  margin: 5em;
  text-align: right;
`

const MobileNav = styled(Nav)`
  text-align: left;
  margin: auto;
  width: 312px;
  padding-left: 0px;
  padding-top: 20px;
`

const StyledLi = styled.li`
  color: white;
`

const MobileLi = styled(StyledLi)`
  display: inline-block;
`

const MobileButton = styled(Button)`
  font-size: 1em;
  width: 100px;
  margin: 2px;
  padding: 10px;
  border: 3px solid white;
`

const DesktopOrLaptopView = () => {
  return(
    <Nav className='menu'>
      <Button><Link style={{textDecoration: 'none'}} to='/contact'><StyledLi>Contact</StyledLi></Link></Button>
      <li><a href='https://yebo.merchdirect.com/' target='_blank' rel="noopener noreferrer"><Button>Store</Button></a></li>
      <Button><Link style={{textDecoration: 'none'}} to='/about'><StyledLi>About</StyledLi></Link></Button>
    </Nav>
  )
}

const TabletOrMobileView = () => {
  return(
    <MobileNav>
      <MobileButton><Link style={{textDecoration: 'none'}} to='/contact'><MobileLi>Contact</MobileLi></Link></MobileButton>
      <MobileLi><a href='https://yebo.merchdirect.com/' target='_blank' rel="noopener noreferrer"><MobileButton>Store</MobileButton></a></MobileLi>
      <MobileButton><Link style={{textDecoration: 'none'}} to='/about'><MobileLi>About</MobileLi></Link></MobileButton>
    </MobileNav>
  )
}

const Menu = () => {

  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1224px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

  return(
    <div>
      { isDesktopOrLaptop && <DesktopOrLaptopView /> }
      { isTabletOrMobile && <TabletOrMobileView /> }
    </div>
  )
}

export default Menu
